export const LocalStorageKeys = {
  LAST_ACTIVITY: 'lastActivity',
  LAST_DASHBOARD_URL_SLUGS: 'lastDashboardUrlSlugs',
  MOTD: 'motd',
};

/**
 * Sets last user activity to local storage
 * @param {number} lastActivity
 */
export const setLastActivityToLocalStorage = (lastActivity: number) => {
  return localStorage.setItem(LocalStorageKeys.LAST_ACTIVITY, lastActivity.toString());
};

/**
 * Gets last user activity from local storage
 */
export const getLastActivityFromLocalStorage = (): number => {
  const lastActivityInLocalStorage = localStorage.getItem(LocalStorageKeys.LAST_ACTIVITY);
  return lastActivityInLocalStorage ? parseInt(lastActivityInLocalStorage, 10) : 0;
};

export const motd = {
  remove() {
    localStorage.removeItem(LocalStorageKeys.MOTD);
  },
  get acknowledged() {
    return Boolean(localStorage.getItem(LocalStorageKeys.MOTD));
  },

  set acknowledged(state: boolean) {
    localStorage.setItem(LocalStorageKeys.MOTD, state.toString());
  },
};
